import { moveToFulfilled, moveToPendingIfNotFulfilled, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { CollaboratorUpdateAction } from '../../domains/threadCollaboratorUpdate/actions.types';

import type { ThreadCollaboratorUpdates } from './types';

const initialState: ThreadCollaboratorUpdates = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};
const reducer: Reducer<ThreadCollaboratorUpdates, CollaboratorUpdateAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'COLLABORATORS.UPDATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.threadCollaboratorUpdates);
    case 'COLLABORATORS.UPDATE_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'COLLABORATORS.UPDATE_PENDING':
      return moveToPendingIfNotFulfilled(state, action.payload.id);
    default:
      return state;
  }
};
export default reducer;
